import esfns from 'date-fns/locale/es';
import ptfns from 'date-fns/locale/pt';
import { registerLocale } from 'react-datepicker';

esfns.options.weekStartsOn = 0;
ptfns.options.weekStartsOn = 0;
registerLocale('es', esfns);
registerLocale('pt', ptfns);
